import type { PasswordRequirement } from '../components/global/PasswordRequirementsList/PasswordRequirementsList.tsx';

export const passwordRequirements: PasswordRequirement[] = [
  { check: (value) => value.length >= 8, key: 'mustHaveEightChars' },
  { check: (value) => /[0-9]/.test(value), key: 'mustContainNumber' },
  { check: (value) => /[a-z]/.test(value), key: 'mustContainLowercase' },
  { check: (value) => /[A-Z]/.test(value), key: 'mustContainUppercase' },
  {
    check: (value) => /[!@#$%^&*()_+}{';'?>.<,]/.test(value),
    key: 'mustContainSpecialChar',
  },
  { check: (value) => !/\s/.test(value), key: 'noSpacesAllowed' },
];
